<template>
  <!-- 8. 新闻资讯 -->
  <div class="info-news">
    <div class="news-content-container">
      <!-- <div class="news-red-block"></div> -->
      <div class="news-picture">
        <el-carousel
          ref="news-carousel"
          class="news-carousel"
          trigger="click"
          height="820px"
          arrow="never"
          :interval="5000"
          @change="newsTabIndex = $event"
        >
          <el-carousel-item v-for="(item, index) in newsList" :key="index" @click="toNewDetial(item.id)">
            <el-image :src="item.cover" fit="scale-down" />
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <div class="news-list-container">
      <div class="pi-justify-between pi-pd-left-92 pi-align-center">
        <div class="pi-fz-30 pi-fw-900 p">新闻资讯</div>
        <div class="news-more-box">
          <router-link to="/aboutus/news">
            <div class="news-more-button">
              <span>查看更多</span>
              <i class="iconfont iconweibiaoti40"></i>
            </div>
          </router-link>
        </div>
      </div>
      <div class="news-list pi-pd-top-40">
        <div
          class="news-item"
          :class="{ 'news-active': index == newsTabIndex }"
          v-for="(item, index) in newsList"
          :key="index"
          @mouseover="changeNews(index)"
          @click="toNewDetial(item.id)"
        >
          <div class="item-symbol"></div>
          <div class="news-title-box">
            <span class="news-title">{{ item.title }}</span>
            <span class="news-sub-title">{{ item.desc }}</span>
          </div>
          <div class="news-date-box">
            <span class="news-date">{{ item.time | newdateFormat }}</span>
            <i class="iconfont iconweibiaoti40 news-icon"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatDate } from "@/utils/date-util";
import newData from "@/views/aboutus/news/news.js";
import { slicingArray, numberFormat } from "@/utils";
export default {
  data() {
    return {
      newsList: [],
      newsTabIndex: 0,
    };
  },
  filters: {
    newdateFormat(val) {
      // console.log('newdateFormat( 。。。 ', val);
      return formatDate(val, "MM.dd");
    },
  },
  created() {
    this.loadNew();
  },
  methods: {
    changeNews(index) {
      this.newsTabIndex = index;
      this.$refs["news-carousel"].setActiveItem(index);
    },
    toNewDetial(newId) {
      let url = `/aboutus/news/detail?id=${newId}`;
      this.$router.push({ path: url });
    },
    loadNew() {
      this.newsList = newData.filter((value) => {
        return value.recommend;
      });
      this.newsList=this.newsList.splice(0,5)
    },
  },
};
</script>

<style lang="scss" scoped>
// 新闻资讯
.info-news {
  padding: 0 160px;
  padding-bottom: 42px;
  padding-top: 67px;
  background-color: #f5f5f5;
  width: 100vw;

  display: flex;
  justify-content: space-between;

  // 新闻图片
  .news-content-container {
    // margin-left: 50px;
    width: 50%;
    height: 590px;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    z-index: 10;

    .news-picture {
      // width: 820px;
      width: 100%;

      .news-carousel {
        height: 590px;
        overflow: hidden;
      }

      .el-image {
        width: 100%;
        // width: 820px;
        height: 510px;
      }
    }

    .news-red-block {
      min-width: 110px;
      height: 110px;
      background-color: #ec0022;
    }
  }

  // 新闻列表
  .news-list-container {
    width: calc(50%);
    height: 590px;
    z-index: 1;

    .news-more-box {
      height: 70px;

      display: flex;
      justify-content: flex-end;

      .news-more-button {
        width: 150px;
        height: 50px;
        padding: 0 10px 0 30px;
        line-height: 50px;
        background: unset;
        border: 1px solid #ec0022;
      }

      .news-more-button:hover {
        cursor: pointer;
        background-color: #ec0022;

        span,
        i {
          color: #fff;
        }
      }
    }

    .news-list {
      padding-left: 92px;
      // height: 520px;
      background-color: #f5f5f5;

      .news-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #eeeeee;

        .item-symbol {
          width: 6px;
          height: 6px;
          background-color: #929292;
        }

        .news-title-box {
          // max-width: 500px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          padding: 15px;
          display: flex;
          flex: 1;
          flex-direction: column;
          align-items: flex-start;
          text-align: left;

          span {
            width: 100%;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .news-title {
            font-size: 24px;
            font-weight: bold;
          }
        }

        .news-date-box {
          padding-left: 20px;
          display: flex;
          flex-direction: column;
          align-items: center;

          .news-date {
            font-size: 24px;
            font-weight: bold;
          }

          .news-icon {
            color: #c5c5c5;
          }
        }
      }

      .news-active {
        .item-symbol {
          height: 50px;
          background-color: #ec0022;
          animation: newsItem 0.4s;
          -webkit-animation: newsItem 0.4s;
        }

        .news-icon {
          color: #ec0022 !important;
        }
      }

      .news-item:hover {
        cursor: pointer;

        // .item-symbol {
        //   height: 50px;
        //   background-color: #ec0022;
        //   animation: newsItem 0.4s ;
        //   -webkit-animation: newsItem 0.4s ;
        // }

        // .news-icon {
        //   color: #ec0022;
        // }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/index/components/row_6/index.vue